import simg1 from '../images/services/icon-1.svg'
import simg2 from '../images/services/icon-2.svg'
import simg3 from '../images/services/icon-3.svg'
import simg4 from '../images/services/icon-4.svg'
import simg5 from '../images/services/icon-5.svg'
import simg6 from '../images/services/icon-6.svg'

import sSimg1 from '../images/service-single/one.webp'
import sSimg2 from '../images/service-single/two.webp'
import sSimg3 from '../images/service-single/three.webp'
import sSimg4 from '../images/service-single/four.webp'
import sSimg5 from '../images/service-single/five.webp' 
import sSimg6 from '../images/service-single/six.webp'

// import icon4 from '../../images/products/icons/4.svg';





const Services = [
   {
      Id: '01',
      sImg: simg1,
      sSImg: sSimg1,
      title: 'Web App Development',
      slug: 'web-app-development',
      description: 'We build custom web applications end-to-end, ensuring high performance, user satisfaction and long-term reliability.',
      content: `
  <p>At <strong>THINKBIG INFOTECH</strong>, we specialize in building scalable, secure, and user-friendly web applications tailored to your business goals. Our full-cycle web app development services cover everything from ideation and UI/UX design to backend development, integration, and deployment.</p>
  
  <p>Our expert developers leverage the latest technologies such as React.js, Node.js, MongoDB, and cloud platforms to ensure your application is fast, responsive, and future-ready. Whether you need a customer portal, business dashboard, or SaaS product, we deliver robust web apps that help drive growth and efficiency.</p>
  
  <p>We follow agile methodologies, ensuring continuous delivery, iterative improvements, and seamless collaboration throughout the project lifecycle. With THINKBIG INFOTECH as your partner, you get more than just a web app you get a digital solution engineered for long-term success.</p>
  
  <ul>
    <li> Custom Web App Design and Development</li>
    <li> Responsive Frontend</li>
    <li> Secure Backend Architecture</li>
    <li> API Integration and Development</li>
    <li> Performance Optimization</li>
    <li> Cloud Deployment and DevOps</li>
    <li> Ongoing Maintenance and Support</li>
  </ul>
`

   },
    {
      Id: '02',
      sImg: simg3,
      sSImg: sSimg2,
      title: 'Mobile App Development',
      slug: 'mobile-app-development',
      description: 'We build responsive, feature-rich mobile applications that offer seamless user experiences across Android and iOS platforms.',
      content: `
  <p><strong>THINKBIG INFOTECH</strong> delivers high-performing, feature-rich mobile applications that provide seamless user experiences across Android and iOS platforms. Whether you’re building a consumer-facing app, enterprise solution, or MVP, our team ensures end-to-end mobile development tailored to your goals.</p>

  <p>We combine cutting-edge technology with intuitive design to create mobile apps that are not only visually engaging but also reliable and scalable. From native apps using Swift and Kotlin to cross-platform solutions with Flutter or React Native, we bring your vision to life with precision and innovation.</p>

  <p>Our process includes strategic planning, UI/UX design, development, testing, and deployment to app stores. We also offer post-launch support and performance optimization to ensure your app stays ahead in a competitive market.</p>

  <ul>
    <li> Android & iOS App Development</li>
    <li> Cross-platform Solutions </li>
    <li> User-Centered UI/UX Design</li>
    <li> API Integration & Backend Connectivity</li>
    <li> App Store Deployment</li>
    <li> Secure Authentication</li>
    <li> Maintenance and Continuous Improvement</li>
  </ul>
`

  },
   
     {
      Id: '03',
      sImg: simg5,
      sSImg: sSimg3,
      title: 'UI/UX',
      slug: 'ui-ux',
      description: 'Our design experts craft intuitive and visually compelling interfaces that enhance user engagement and satisfaction.',
      content: `
  <p>At <strong>THINKBIG INFOTECH</strong>, we believe that exceptional design drives exceptional user experiences. Our UI/UX design services focus on creating intuitive, engaging, and accessible interfaces that not only look stunning but also enhance usability and user satisfaction.</p>

  <p>We conduct in-depth user research, wireframing, prototyping, and usability testing to ensure every design decision aligns with your brand, audience, and goals. Whether you're building a new digital product or redesigning an existing one, we turn complex ideas into simple, elegant, and user-centered solutions.</p>

  <p>Our collaborative design process ensures that your app or website feels natural and enjoyable to use — maximizing engagement, retention, and conversions.</p>

  <ul>
    <li> Creative Visual Design</li>
    <li> User Research and Journey Mapping</li>
    <li> Wireframes and Interactive Prototypes</li>
    <li> Mobile-First and Responsive Design</li>
    <li> Usability Testing and Feedback Integration</li>
    <li> UI Kits and Design Systems</li>
    <li> Design-to-Development Handoff</li>
  </ul>
`

   },
   {
      Id: '04',
      sImg: simg6,
      sSImg: sSimg4,
      title: 'Cloud Infrastructure',
      slug: 'cloud-infrastructure',
      description: 'We provide robust cloud infrastructure services to ensure scalability, security and performance for your business needs.',
        content: `
  <p><strong>THINKBIG INFOTECH</strong> provides scalable and secure cloud infrastructure solutions that empower your business to innovate, grow, and operate with agility. We help organizations migrate, manage, and optimize their workloads on leading cloud platforms like AWS, Microsoft Azure, and Google Cloud.</p>

  <p>Our cloud experts design reliable architectures that ensure high availability, data protection, and cost efficiency. Whether you're launching a new application, modernizing your infrastructure, or looking for managed cloud services, we deliver solutions that support your digital transformation journey.</p>

  <p>We follow industry best practices and DevOps principles to build cloud-native systems that are resilient, scalable, and future-ready — giving your business a competitive edge in the digital era.</p>

  <ul>
    <li> Cloud Strategy and Consulting</li>
    <li> Cloud Migration Services</li>
    <li> Infrastructure as Code </li>
    <li> Auto-scaling and Load Balancing</li>
    <li> Security and Compliance Setup</li>
    <li> Cloud Monitoring and Optimization</li>
    <li> DevOps and CI/CD Implementation</li>
  </ul>
`

   },
   
   
   {
      Id: '05',
      sImg: simg4,
      sSImg: sSimg5,
      title: 'IT Staffing',
      slug: 'it-staffing',
      description: 'We connect businesses with highly skilled IT professionals, offering flexible staffing solutions to scale your team effectively.',
   content: `
  <p><strong>THINKBIG INFOTECH</strong> offers flexible and reliable IT staffing solutions to help you scale your team with top-tier talent. We connect businesses with highly skilled developers, engineers, designers, QA testers, and other IT professionals who seamlessly integrate with your in-house teams or work as dedicated resources.</p>

  <p>Our deep understanding of technology and industry needs enables us to match the right talent with the right projects — whether you need short-term contract staff, long-term project teams, or full-time hires. We help reduce hiring time, cut operational costs, and ensure faster delivery of your IT goals.</p>

  <p>Let us handle the hiring, onboarding, and management of expert professionals so you can focus on growing your business with agility and confidence.</p>

  <ul>
    <li> On-Demand IT Talent</li>
    <li> Skilled Developers and Engineers</li>
    <li> Project-Based Staffing</li>
    <li> Contract, Contract-to-Hire and Full-Time</li>
    <li> Rapid Hiring Turnaround</li>
    <li> Pre-vetted and Technically Screened Profiles</li>
    <li> Remote and On-site Resource Availability</li>
  </ul>
`

   },
   {
      Id: '06',
      sImg: simg2,
      sSImg: sSimg6,
      title: 'Offshore Development',
      slug: 'offshore-development',
      description: 'Our offshore development model delivers cost-efficient, high-quality software development through dedicated remote teams.',
      content: `
  <p><strong>THINKBIG INFOTECH</strong> provides cost-effective and high-quality offshore development services through dedicated remote teams tailored to your project needs. Our offshore model enables businesses to access world-class talent, reduce operational costs, and accelerate time-to-market — all without compromising on quality or control.</p>

  <p>We work as an extension of your in-house team, offering complete transparency, seamless communication, and full project ownership. From software development and QA testing to UI/UX design and DevOps, our offshore teams deliver reliable and scalable solutions across various domains.</p>

  <p>Whether you're a startup, SME, or enterprise, THINKBIG INFOTECH helps you build and manage offshore development centers that drive efficiency, innovation, and long-term success.</p>

  <ul>
    <li> Dedicated Offshore Teams</li>
    <li> Cost-Effective Development Model</li>
    <li> Full-Cycle Software Development</li>
    <li> Agile Development and Project Management</li>
    <li> Secure Collaboration and IP Protection</li>
    <li> Seamless Communication and Time Zone Alignment</li>
    <li> Scalable Resource Allocation</li>
  </ul>
`

   },
   

]

export default Services;